import React, {useEffect, useMemo, useRef, forwardRef} from 'react';
import {Editor} from '@tinymce/tinymce-react';
import debounce from 'lodash/debounce';
import "tinymce/tinymce.min.js";
// Icons, theme, model, skin is required
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/models/dom/model";
import 'tinymce/skins/ui/oxide/skin.min.css';
// tinymce plugins
import 'tinymce/plugins/link';
import 'tinymce/plugins/code';
import 'tinymce/plugins/image';

import {initialProps, parseHTML, shouldEmitChange} from './utils';

import './EmailMessage.scss';

type Callback = (value?: any) => void;

interface EmailMessageProps {
  defaultValue: string;
  disabled?: boolean;
  onChange: Callback;
}

export const EmailMessageComponent = forwardRef(({
  defaultValue,
  disabled = false,
  onChange,
}: EmailMessageProps, ref: any) => {
  const editorRef = useRef<any>(null);

  useEffect(() => {
    return () => {
      if (ref) {
        ref.current = null;
      }

      if (debounceOnChange && debounceOnChange.hasOwnProperty('cancel')) {
        debounceOnChange.cancel();
      }
    };
  }, []);

  const initProps = useMemo(() => initialProps(), []);
  const debounceOnChange = useMemo(() => debounce(onChange, 400), [onChange]);

  const onInit = (event: any, editor: any) => {
    if (ref) {
      ref.current = editor;
    }
    editorRef.current = editor;
  };

  const onEditorChange = (value: any, editor: any) => {
    if (editor.mode.isReadOnly()) {
      return;
    }
    let content = parseHTML(editor.getContent());

    const emit = shouldEmitChange(editor, content);

    if (emit) {
      debounceOnChange(content);
    }
  };

  return (
    <Editor
      onInit={onInit}
      onEditorChange={onEditorChange}
      init={initProps}
      initialValue={defaultValue}
      disabled={disabled}
    />
  );
});

export const EmailMessage = React.memo(EmailMessageComponent);
export default EmailMessage;
